type WallData = string;
export type MissionProgress = {
    type: string;
    goal: number;
    index: number;
    progress: number;
    reward: number;
    completed: boolean;
};
export type CompletedMissionData = {
    [key: string]: number;
}

export default class SaveData {
    firstTimeUser = true;
    launchedSlingshot = false;
    seenSlamTut = false;
    boughtItem = false;
    wallData: WallData[] = ["", "", "", ""];
    coins = 0;
    items: { [key: string]: number } = {
        rubberBand: 0,
        grease: 0,
        anvil: 0,
        detonator: 0,
        steelBall: 0,
    };
    missions: MissionProgress[] = [null, null, null];
    completedMissions: CompletedMissionData = {};
    lastMissionIndex: number[] = [-1, -1, -1];

    currentCharacter = 0;
    charactersUnlocked = 0;
    slamsUnlocked = 0;
    missionsToNextCharacterUnlock = 0;
    missionsCompleteForCharacterUnlock = 0;
    newCharacterSelected = false;
}